export default function (data) {
  return {
    chart: {
      type: "bar",
      backgroundColor: "rgba(0,0,0,0)",
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    xAxis: {
      categories: data.map((item) => item.typeName),
      title: {
        text: null,
      },
      lineWidth: 0,
      labels: {
        style: {
          color: "#B4E4FF",
        },
      },
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      pointFormat: "<b>" + "{point.y}" + " </b>",
    },
    yAxis: {
      min: 0,
      // max:
      //   Math.max(...data.map((item) => item.value)) === 0
      //     ? 9999
      //     : Math.max(...data.map((item) => item.value)),
      title: {
        text: "",
        align: "high",
      },
      gridLineWidth: 1,
      gridLineColor: "#2B79BB",
      lineWidth: 0,
      labels: {
        overflow: "justify",
        enabled: true,
        style: {
          color: "#B4E4FF",
        },
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        pointInterval: 1,
        pointPadding: 0,
        groupPadding: 0,
        borderColor: "#fff",
        pointWidth: 12, //设置柱子宽度
        dataLabels: {
          enabled: true,
          allowOverlap: false, // 允许数据标签重叠
          style: {
            fontSize: "0.75rem",
            color: "#fff",
            textOutline: "none",
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        data: data.map((item) => item.number),
        color: "#7CB5EC",
      },
    ],
  };
}
